module.exports = __webpack_public_path__ + "img/car_3.e615ad09.jpeg";